import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {
	DROP_TYPES,
	FONTS,
	GRAY,
	PRIMARY_COLOR,
	ROUTES,
	SECONDARY_COLOR,
} from "../constants";
import gear from "../media/gear_white.svg";

import VariableImportanceIcon from "../media/drawerIcons/bar-chart_white.png";
import Correlation from "../media/drawerIcons/correlation.png";
import ModelTrainingIcon from "../media/drawerIcons/deep-learning.png";
import Ingest from "../media/drawerIcons/file.png";
import Persona from "../media/drawerIcons/man.png";
import NLPIcon from "../media/drawerIcons/nlp.png";
import Batch from "../media/drawerIcons/predictive-chart.png";
import { stateType } from "../state";
import { DataTab } from "./DataIngestion/DataIngestion";
import { processDroppedData } from "./DataIngestion/DropZoneBox";
import { TopBar } from "./TopBar";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import React, { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { notifyPageView } from "../analytics/useAnalyticsEventTracker";
import { setMetaTags } from "../helpers/pageMeta";
import VariableImportanceW from "../media/drawerIcons/bar-chart.png";
import Clean from "../media/drawerIcons/broom_black.png";
import CleanW from "../media/drawerIcons/broom_white.png";
import CorrelationW from "../media/drawerIcons/correlation_white.png";
import ModelTrainingW from "../media/drawerIcons/deep-learning_white.png";
import Sent from "../media/drawerIcons/emoticons.png";
import SentW from "../media/drawerIcons/emoticonsW.png";
import IngestW from "../media/drawerIcons/file_white.png";
import PersonaW from "../media/drawerIcons/man_white.png";
import NLPIconW from "../media/drawerIcons/nlp_white.png";
import BatchW from "../media/drawerIcons/predictive-chart_white.png";
import { BacthPrediction } from "./BatchPrediction/BatchPrediction";
import { AreYouSurePopup } from "./Common/AreYourSurePopup";
import { LoadingDialog } from "./Common/LoadingDialog";
import { DataCleaning } from "./DataCleaning/DataCleaning";
import { FAQ } from "./FAQ/FAQ";
import { LoadingDashboard } from "./LoadinDashboard";
import { LogOut } from "./LogOut/LogOut";
import { ModelTraining } from "./ModelTraining/ModelTraining";
import { NewDashPopup } from "./NewDashPopup";
import { PersonaGroupings } from "./PersonaGroupings/PersonaGroupings";
import { PersonaPrediction } from "./PersonaPrediction/PersonaPrediction";
import { sampleData } from "./sampledata";
import { SentimentAnalysis } from "./SentimentAnalysis/SentimentAnalysis";
import { ShareBanner } from "./ShareBanner";
import { VariableCorrelations } from "./VariableCorrelations/VariableCorrelations";
import { VariableImportance } from "./VariableImportance/VariableImportance";

const color = "white"; //"rgb(118, 7, 143)"
export const drawerWidth = 250;

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: "flex",
		},
		savedDashMenu: {
			"&:hover": {
				backgroundColor: "rgb(50,50,50)",
			},
			transition: "0.2s",
		},
		grid: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "center",
			maxWidth: "1200px",
			alignSelf: "center",
			whiteSpace: "nowrap",
			marginTop: "80px",
			marginBottom: "-80px",
		},
		root2: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
		},

		deleteIcon: {
			"&:hover": {
				color: SECONDARY_COLOR,
			},
			transition: "0.2s",
			cursor: "pointer",
		},
		nested: {
			paddingLeft: theme.spacing(3),
			height: "40px",
			borderRadius: "10px",
			width: "90%",
			marginLeft: "10px",
			transition: "all .5s",

			"&$selected": {
				backgroundColor: SECONDARY_COLOR,
				opacity: 0.85,
				color: "white",
				"&:hover": {
					backgroundColor: SECONDARY_COLOR,
					opacity: 0.75,
				},
			},
		},
		drawer: {
			width: drawerWidth,
			flexShrink: 0,
		},
		drawerPaper: {
			width: drawerWidth,
			backgroundColor: "rgb(256,256,256)",
			marginTop: "50px",
		},
		toolbar: theme.mixins.toolbar,
		// necessary for content to be below app bar
		content: {
			flexGrow: 1,
			backgroundColor: GRAY,
			padding: theme.spacing(3),
			minHeight: "100vh",
		},
		appBar: {
			width: "100%",
			marginLeft: drawerWidth,
		},
		groupImage: {
			transform: "scale(1)",
			width: "20px",
			height: "20px",
		},
		groupImageRight: {
			transform: "scale(1)",
			width: "20px",
			height: "20px",
			marginRight: "-15px",
		},
		nameTop: {
			marginLeft: "10px",
			marginRight: "00px",
			fontSize: "40px",
			width: "100%",
			color: color,
			fontFamily: "Roboto,Arial,Helvetica,sans-serif",
		},
		test: {
			width: "90%",
			marginLeft: "10px",
			borderRadius: "10px",
		},
		logoNameContainer: {
			display: "flex",
			flexDirection: "row",
		},
		gear: {
			width: "45px",
			transition: "transform .7s ease-in-out",
			"&:hover": {
				transform: "rotate(360deg)",
			},
		},
		selected: {},
		topBlockBackground: {
			backgroundImage:
				"radial-gradient(#171228, #141329, #11142a, #0d152b, #0f1223, #0e0e1b, #0b0a12, #060606)",
			display: "flex",
			height: "100vh",
			width: "100vw",
		},
		rootMenuItem: {
			color: PRIMARY_COLOR,
			"&$selected": {
				backgroundColor: SECONDARY_COLOR,
				opacity: 0.75,
				color: "white",
				"&:hover": {
					backgroundColor: SECONDARY_COLOR,
					opacity: 0.85,
				},
			},
		},
	})
);

function HomeIcon({ icon }) {
	const classes = useStyles();
	return <img src={icon} className={classes.groupImage}></img>;
}

type drawerItemType = {
	text: string;
	subText: string[];
	icon?: string;
	subIcons?: string[];
	rightIcon?: string;
	isSelected: boolean;
	subIsSelected: boolean[];
	route: string;
	subItemRoutes: string[];
};

export const LogoNameMainPageScroll = () => {
	const classes = useStyles();
	return (
		<div className={classes.logoNameContainer}>
			<img src={gear} className={classes.gear}></img>
			<h1 className={classes.nameTop}>Dash AI</h1>
		</div>
	);
};
function MobileUnavailable() {
	const classes = useStyles();
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				width: "100vw",
			}}
			className={classes.topBlockBackground}
		>
			<div style={{ marginTop: "-100px" }}>
				<LogoNameMainPageScroll></LogoNameMainPageScroll>
			</div>
			<div
				style={{
					color: color,
					fontFamily: FONTS,
					fontSize: "20px",
					fontWeight: "bold",
					textAlign: "center",
				}}
			>
				Unsupported Platform
			</div>
			<div
				style={{
					color: color,
					fontFamily: FONTS,
					fontSize: "14px",
					textAlign: "center",
					margin: "10px",
				}}
			>
				Dash AI is only supported on desktop at the moment. <br></br>{" "}
				Come check us out again on a PC!
			</div>
		</div>
	);
}

export function Dashboard({ state }: stateType) {
	const classes = useStyles();
	const { pathname } = useLocation();
	const [anchorEl, setAnchorEl] = React.useState(null);

	useEffect(() => {
		setMetaTags();
		if (isMobile) {
			notifyPageView("Mobile Page", "/mobile");
			return;
		}
		localStorage.setItem("tempFileName", "Women's Clothing Reviews.csv");

		processDroppedData(
			state,
			sampleData,
			"Loading Data...",
			true,
			new Set(),
			undefined,
			DROP_TYPES.newDashPopup
		);
	}, []);
	if (isMobile) {
		return <MobileUnavailable></MobileUnavailable>;
	}
	function handleClick(event) {
		if (anchorEl !== event.currentTarget) {
			setAnchorEl(event.currentTarget);
		}
	}

	function handleClose() {
		setAnchorEl(null);
	}

	function DrawerItem({
		text,
		subText,
		icon,
		subIcons,
		rightIcon,
		isSelected,
		subIsSelected,
		route,
		subItemRoutes,
	}: drawerItemType) {
		//const [open, setOpen] = React.useState(true);
		const classes = useStyles();

		return (
			<div style={{ whiteSpace: "nowrap" }}>
				{subText.length > 0 ? (
					<ListItem key={text} selected={isSelected}>
						<ListItemText
							primary={
								<Typography
									style={{
										color: PRIMARY_COLOR,
										fontWeight: "bold",
										fontSize: "13px",
									}}
								>
									{text}
								</Typography>
							}
						/>
					</ListItem>
				) : (
					<Link
						to={route === undefined ? pathname : route}
						style={{ textDecoration: "none" }}
					>
						<ListItem
							button
							key={text}
							className={classes.test}
							classes={{
								selected: classes.selected,
								root: classes.rootMenuItem,
							}}
							selected={isSelected}
						>
							<ListItemIcon style={{ marginLeft: "0px" }}>
								{icon !== undefined ? (
									<img
										src={icon}
										className={classes.groupImage}
									></img>
								) : (
									""
								)}
							</ListItemIcon>
							<ListItemText
								primary={
									<Typography
										style={{
											fontFamily: "Futura, Arial",
											marginLeft: "-17px",
										}}
									>
										{text}
									</Typography>
								}
							/>
							{rightIcon !== undefined ? (
								<img
									src={rightIcon}
									className={classes.groupImageRight}
								></img>
							) : (
								""
							)}
						</ListItem>
					</Link>
				)}

				<List component="div" disablePadding>
					{subText.map((text, i) => (
						<Link
							to={
								subItemRoutes[i] === undefined
									? pathname
									: subItemRoutes[i]
							}
							style={{ textDecoration: "none" }}
						>
							<ListItem
								button
								classes={{
									selected: classes.selected,
									root: classes.rootMenuItem,
								}}
								className={classes.test}
								selected={subIsSelected[i]}
							>
								<ListItemIcon>
									{subIcons !== undefined ? (
										<HomeIcon icon={subIcons[i]}></HomeIcon>
									) : (
										""
									)}
								</ListItemIcon>
								<ListItemText
									primary={
										<Typography
											style={{
												fontFamily: "Futura, Arial",
												fontSize: "13px",
												marginLeft: "-15px",
											}}
										>
											{text}
										</Typography>
									}
								/>
							</ListItem>
						</Link>
					))}
				</List>
			</div>
		);
	}

	let trainProgress =
		state.saveState.modelTraining.totalTrainProgress > 0 &&
		state.saveState.modelTraining.totalTrainProgress < 100 &&
		!window.location.href.endsWith("training")
			? " (" +
			  Math.round(state.saveState.modelTraining.totalTrainProgress) +
			  "%)"
			: "";

	let labels: drawerItemType[] = [
		{
			text: "Data",
			subText: ["Data Upload", "Cleaning", "Correlations"],
			subIcons: [
				pathname === ROUTES.data_ingestion ? IngestW : Ingest,
				pathname === ROUTES.data_cleaning ? CleanW : Clean,
				pathname === ROUTES.variable_correlation
					? CorrelationW
					: Correlation,
			],
			isSelected: false,
			subIsSelected: [
				pathname === ROUTES.data_ingestion,
				pathname === ROUTES.data_cleaning,
				pathname === ROUTES.variable_correlation,
			],
			route: "/",
			subItemRoutes: [
				ROUTES.data_ingestion,
				ROUTES.data_cleaning,
				ROUTES.variable_correlation,
			],
		},
		{
			text: "Natural Language Processing",
			subText: ["Topic Modeling", "Sentiment Analysis"],
			subIcons: [
				pathname === ROUTES.nlp ? NLPIconW : NLPIcon,
				pathname === ROUTES.sentiment ? SentW : Sent,
			],
			isSelected: false,
			subIsSelected: [
				pathname === ROUTES.nlp,
				pathname === ROUTES.sentiment,
			],
			route: undefined,
			subItemRoutes: [ROUTES.nlp, ROUTES.sentiment],
		},
		{
			text: "Machine Learning",
			subText: [
				"Model Training " + trainProgress,
				"Variable Importance",
				"Persona Prediction",
				"Batch Prediction",
			],
			subIcons: [
				pathname === ROUTES.model_training
					? ModelTrainingW
					: ModelTrainingIcon,
				pathname === ROUTES.var_importance
					? VariableImportanceW
					: VariableImportanceIcon,
				pathname === ROUTES.persona_prediction ? PersonaW : Persona,
				pathname === ROUTES.batch_prediction ? BatchW : Batch,
				pathname === ROUTES.nlp ? NLPIconW : NLPIcon,
			],
			isSelected: false,
			subIsSelected: [
				pathname === ROUTES.model_training,
				pathname === ROUTES.var_importance,
				pathname === ROUTES.persona_prediction,
				pathname === ROUTES.batch_prediction,
				pathname === ROUTES.nlp,
			],
			route: undefined,
			subItemRoutes: [
				ROUTES.model_training,
				ROUTES.var_importance,
				ROUTES.persona_prediction,
				ROUTES.batch_prediction,
				ROUTES.nlp,
			],
		},
	];

	let labels2: drawerItemType[] = [
		// {
		// 	text: "FAQ",
		// 	subText: [],
		// 	icon: pathname === ROUTES.faq ? FAQW : FAQIcon,
		// 	isSelected: pathname === ROUTES.faq,
		// 	subIsSelected: [],
		// 	route: ROUTES.faq,
		// 	subItemRoutes: [],
		// },
		// {
		//   text: "Log Out",
		//   subText: [],
		//   icon: pathname === ROUTES.logout ? LogoutW : Logout,
		//   isSelected: pathname === ROUTES.logout,
		//   subIsSelected: [],
		//   route: ROUTES.logout,
		//   subItemRoutes: [],
		// },
	];
	let labels3: drawerItemType[] = [];
	function handleDeleteClick(name: string) {
		state.setDashToDelete(name);
		setAnchorEl(null);
		state.setIsDeleteDashOpen(true);
	}
	return (
		<div className={classes.root}>
			<TopBar state={state}></TopBar>

			<Drawer
				className={classes.drawer}
				variant="permanent"
				classes={{
					paper: classes.drawerPaper,
				}}
				anchor="left"
			>
				<List>
					{labels3.map((val, index) => (
						<div>
							<div onClick={handleClick}>
								<DrawerItem
									text={val.text}
									subText={val.subText}
									icon={val.icon}
									subIcons={val.subIcons}
									rightIcon={val.rightIcon}
									isSelected={val.isSelected}
									subIsSelected={val.subIsSelected}
									route={val.route}
									subItemRoutes={val.subItemRoutes}
								></DrawerItem>
							</div>
						</div>
					))}
				</List>
				<Divider />
				<List>
					{labels.map((val, index) => (
						<DrawerItem
							text={val.text}
							subText={val.subText}
							icon={val.icon}
							subIcons={val.subIcons}
							isSelected={val.isSelected}
							subIsSelected={val.subIsSelected}
							route={val.route}
							subItemRoutes={val.subItemRoutes}
						></DrawerItem>
					))}
				</List>
				<div style={{ marginBottom: "10px", marginTop: "auto" }}>
					<Divider />
					<List>
						{labels2.map((val, index) => (
							<DrawerItem
								text={val.text}
								subText={val.subText}
								icon={val.icon}
								subIcons={val.subIcons}
								isSelected={val.isSelected}
								subIsSelected={val.subIsSelected}
								route={val.route}
								subItemRoutes={val.subItemRoutes}
							></DrawerItem>
						))}
					</List>
				</div>{" "}
			</Drawer>
			{state.isFirstLoad ? (
				<main className={classes.content}>
					<div className={classes.root2}>
						<div className={classes.grid}>
							<ShareBanner></ShareBanner>
						</div>
					</div>
					<div className={classes.toolbar} />
					<Routes>
						<Route
							path={"/*"}
							element={
								<Navigate to={ROUTES.data_ingestion}></Navigate>
							}
						/>
						<Route
							path={ROUTES.data_ingestion}
							element={<DataTab state={state}></DataTab>}
						/>
						<Route
							path={ROUTES.data_cleaning}
							element={
								<DataCleaning state={state}></DataCleaning>
							}
						/>
						<Route
							path={ROUTES.variable_correlation}
							element={
								<VariableCorrelations
									state={state}
								></VariableCorrelations>
							}
						/>
						<Route
							path={ROUTES.model_training}
							element={
								<ModelTraining state={state}></ModelTraining>
							}
						/>
						<Route
							path={ROUTES.var_importance}
							element={
								<VariableImportance
									state={state}
								></VariableImportance>
							}
						/>
						<Route
							path={ROUTES.persona_prediction}
							element={
								<PersonaPrediction
									state={state}
								></PersonaPrediction>
							}
						/>
						<Route
							path={ROUTES.batch_prediction}
							element={
								<BacthPrediction
									state={state}
								></BacthPrediction>
							}
						/>
						<Route
							path={ROUTES.nlp}
							element={
								<PersonaGroupings
									state={state}
								></PersonaGroupings>
							}
						/>

						<Route
							path={ROUTES.sentiment}
							element={
								<SentimentAnalysis
									state={state}
								></SentimentAnalysis>
							}
						/>
						<Route
							path={ROUTES.faq}
							element={<FAQ state={state}></FAQ>}
						/>
						<Route
							path={ROUTES.logout}
							element={<LogOut state={state}></LogOut>}
						/>
					</Routes>

					<NewDashPopup state={state}></NewDashPopup>
				</main>
			) : (
				<LoadingDashPopup state={state}></LoadingDashPopup>
			)}

			<LoadingDialog state={state}></LoadingDialog>
			<RejectedDropPopup state={state}></RejectedDropPopup>
			<ErrorPopup state={state}></ErrorPopup>
		</div>
	);
}

function ErrorPopup({ state }: stateType) {
	return (
		<AreYouSurePopup
			state={state}
			title="Something went wrong..."
			message={`Looks like something went wrong, we have been notified and are working hard to fix the issue.`}
			handleCancel={() => state.setErrorPopupOpen(false)}
			handleContinue={() => state.setErrorPopupOpen(false)}
			isOpenTF={state.errorPopupOpen}
			continueLabel="Continue"
		></AreYouSurePopup>
	);
}
function LoadingDashPopup({ state }: stateType) {
	return (
		<Dialog
			open={true}
			maxWidth="sm"
			PaperProps={{
				style: {
					backgroundColor: "rgba(0,0,0,0.75)",
					boxShadow: "none",
				},
			}}
		>
			<DialogContent
				style={{
					display: "flex",
					flexDirection: "row",
				}}
			>
				<LoadingDashboard state={state}></LoadingDashboard>
			</DialogContent>
		</Dialog>
	);
}

function RejectedDropPopup({ state }: stateType) {
	function handleCancel() {
		state.setIsRejectedDropOpen(false);
	}
	if (state.errorPopupOpen && state.isRejectedDropOpen) {
		state.setIsRejectedDropOpen(false);
	}
	return (
		<AreYouSurePopup
			state={state}
			title="Invalid Data"
			message={state.rejectedReason}
			handleCancel={undefined}
			handleContinue={handleCancel}
			isOpenTF={state.isRejectedDropOpen}
			continueLabel="Ok"
		></AreYouSurePopup>
	);
}
